import React from 'react';
import PropTypes from 'prop-types';
import {AzoButton} from "../../../index";
import {Typography, useMediaQuery, useTheme} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import useStyles from "./StopoverCloseButtonStyles";

const StopoverCloseButton = ({title, onClick, icon, disabled, ...props}) => {

    const {breakpoints} = useTheme();
    const isMobile = useMediaQuery(breakpoints.down('xs'));
    const classes = useStyles(isMobile);

    return (
        <AzoButton
            classes={{
                root: classes.button,
                startIcon: classes.buttonStartIcon
            }}
            onClick={onClick}
            disabled={disabled}
            variant={'contained'}
            color={'secondary'}
            size={'small'}
            startIcon={icon}
            disableElevation
            {...props}
        >
            {!isMobile && <Typography variant={'subtitle1'}>{title}</Typography>}
        </AzoButton>
    );
};

StopoverCloseButton.propTypes = {
    title: PropTypes.string,
    onClick: PropTypes.func,
    icon: PropTypes.node,
    disabled: PropTypes.bool,
};

StopoverCloseButton.defaultProps = {
    title: 'Skip Stopover',
    onClick: () => null,
    icon: <CloseIcon/>,
    disabled: false,
};

export default StopoverCloseButton;